import React from 'react';
import fortinetIcon from '../../../../assets/img/desktop/fortinet-logo.png';
import sonicwallIcon from '../../../../assets/img/desktop/sonicwall-logo.png';
import fortinetLogo from '../../../../assets/img/desktop/fortinet-logo.png';
import sonicwallLogo from '../../../../assets/img/desktop/sonicwall-logo.png';
import './CDSeguridadPerimetral.css';

function CDSeguridadPerimetral() {

    return (
        <main id="CDSeguridadPerimetral">
            <section id="CDSP-c1">
                <h2>Seguridad Perimetral</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Ciberseguridad</li>
                    <li>/</li>
                    <li>Seguridad Perimetral</li>
                </ul>
            </section>
            <section id="CDSP-c2">
                <div id="CDSP-c2__text">
                    <h1>Protección Perimetral para su Red Empresarial</h1>
                    <p>La seguridad perimetral es la primera línea de defensa contra amenazas cibernéticas. Proteja su infraestructura de red con firewalls de próxima generación que ofrecen visibilidad, control y protección avanzada contra ataques sofisticados.</p>
                </div>
            </section>
            <section id="CDSP-c3">
                <div className="CDSP-service-card">
                    <div className="CDSP-service-card__icon">
                        <img src={fortinetIcon} alt="Fortinet Icon" />
                    </div>
                    <h3>Fortinet</h3>
                    <p>Fortinet FortiGate ofrece firewalls de próxima generación (NGFW) que combinan funciones de firewall tradicionales con capacidades avanzadas de inspección profunda de paquetes (DPI), prevención de intrusiones (IPS), filtrado de aplicaciones y protección contra amenazas. La plataforma FortiGate utiliza FortiGuard Labs, una de las redes de inteligencia de amenazas más grandes del mundo, para proporcionar protección en tiempo real contra malware, exploits y ataques dirigidos. Con capacidades de SD-WAN integradas y gestión unificada a través de FortiManager, Fortinet ofrece una solución completa de seguridad de red para empresas de todos los tamaños.</p>
                    <div className="CDSP-service-card__logo">
                        <img src={fortinetLogo} alt="Fortinet Logo" />
                    </div>
                </div>
                <div className="CDSP-service-card">
                    <div className="CDSP-service-card__icon">
                        <img src={sonicwallIcon} alt="SonicWall Icon" />
                    </div>
                    <h3>SonicWall</h3>
                    <p>SonicWall ofrece soluciones de seguridad de red de próxima generación diseñadas para proteger a las organizaciones contra amenazas avanzadas. Los firewalls SonicWall TZ y NSa Series proporcionan inspección profunda de paquetes, protección contra malware, filtrado de contenido web y control de aplicaciones. La tecnología Capture Advanced Threat Protection (ATP) de SonicWall utiliza análisis de sandbox en la nube para detectar y bloquear amenazas desconocidas y de día cero. Con capacidades de VPN SSL y gestión centralizada a través de SonicWall Global Management System (GMS), SonicWall ofrece una protección perimetral robusta y escalable para empresas medianas y grandes.</p>
                    <div className="CDSP-service-card__logo">
                        <img src={sonicwallLogo} alt="SonicWall Logo" />
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CDSeguridadPerimetral;

